import { authenticationAPI } from '@navi-app/utils/api';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import config from '../../../commons/constants/config';
import { getRedirectUrl } from '../../../commons/hooks/use-auth';
import companySelectionStore from '../store/company-selection.store';

const useCompanySelection = () => {
  const [searchParams] = useSearchParams();
  const { admin, customers, resetValues } = companySelectionStore();
  const redirectUrl = searchParams.get('redirect');

  const apiAuth = authenticationAPI(config.API_URL || '');
  const mutationLogout = useMutation(apiAuth.logout);

  const onChooseCompany = (userRoleId: string, customerId: string) => {
    Cookies.set('userRoleId', userRoleId, {
      domain: config?.DOMAIN_URL,
    });
    Cookies.set('customerId', customerId, {
      domain: config?.DOMAIN_URL,
    });
    Cookies.set('eligibleToAccess', 'true', {
      domain: config?.DOMAIN_URL,
    });

    const isEligibleToAccess = Cookies.get('eligibleToAccess') === 'true';
    const isUserRoleIdSet = Cookies.get('userRoleId') === userRoleId;
    const isCustomerIdSet = Cookies.get('customerId') === customerId;

    if (isEligibleToAccess && isUserRoleIdSet && isCustomerIdSet) {
      if (redirectUrl) {
        const finalUrl = getRedirectUrl(redirectUrl);
        window.location.replace(finalUrl);
      } else {
        window.location.replace(config.MOBI_URL);
      }
    }
  };

  const logout = () => {
    resetValues();
  };

  const onLogout = () => {
    mutationLogout.mutate(null, {
      onSuccess: logout,
      onError: logout,
    });
  };

  useEffect(() => {
    const authToken = Cookies.get('authToken');
    if (!authToken) {
      window.location.href = '/auth';
    }
  }, []);

  return {
    onChooseCompany,
    onLogout,
    admin,
    customers,
  };
};

export default useCompanySelection;
